/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ERRORS } from './Error.constants';
import { ErrorWithHttpStatusCode } from './ErrorWithHttpStatusCode';

/**
 * Unprocessable content error (422).
 * @export
 * @class UnprocessableContentError
 * @extends {ErrorWithHttpStatusCode}
 */
export class UnprocessableContentError extends ErrorWithHttpStatusCode {
  constructor(
    public details: string,
    message = ERRORS.unprocessableContent.name,
  ) {
    super(ERRORS.unprocessableContent.code, message, details);
  }
}
